import { useAppointmentFeesQuery } from "../../../api/appointments/useAppointmentFeesQuery";

export function useApiAppointmentFees({ appointmentId }) {
  const { data, isFetching } = useAppointmentFeesQuery(
    { appointmentId },
    {
      staleTime: 0,
      enabled: Boolean(appointmentId),
    },
  );

  return {
    appointmentFees: data || { cancelationFee: 0 },
    isAppointmentFeesFetching: isFetching,
  };
}
